import getCombatantIndexById from "./getCombatantIndexById";
import store from "../store/index";
//----------------
// update CR slot
//----------------
export default function updateCRSlot(parm) {
  //--------------
  // access store
  //--------------
  const this_store = store.state.combat;
  let combatants = this_store.arena.arena_combatants;
  //--------------------
  // get combatant index
  //--------------------
  let idx = getCombatantIndexById(parm.combatant);
  //-------------
  // update slug
  //-------------
  let cr = "cr_slug" + parm.cr.number;
  combatants[idx][cr] = parm.cr.slug;
  //-----------------------
  // update reaction count
  //-----------------------
  combatants[idx].reaction_count = parm.cr.reaction_count;
}
